class SelectMultivariants {
  constructor(rootEl) {
    if (!rootEl) throw new Error('SelectMultivariants requires a root element');
    this.root = rootEl;
    this.variantWrapper = this.root.querySelector('.option--variant-wrapper');
    this.addBtn = this.root.querySelector('.add_item');
    this.select = this.root.querySelector('.variant_id');
    this.updatePrice = this.root.querySelector('.price--wrapper');
    this.originalBtnText = this.addBtn ? this.addBtn.textContent.trim() : '';
    this.optionLabels = this.root.querySelectorAll('.option_label span');
    this.addToCartBtn = document.querySelector('.add-items-to-cart');
    this.allVariants = document.querySelectorAll('.options--variant select.variant_id');
    // find the picker (partial) if present
    this.picker = (this.variantWrapper && this.variantWrapper.querySelector('multivariant-selects')) ||
      this.root.querySelector('multivariant-selects');

    // Quantity elements
    this.qtyMinusBtn = this.root.querySelector('.product-quantity__button--minus');
    this.qtyPlusBtn = this.root.querySelector('.product-quantity__button--plus');
    this.qtyInput = this.root.querySelector('.quantity__input');

    this._bindEvents();
    this._bindPickerEvents();
    this._bindQuantityEvents();
    this._checkUrlAndInit();
  }

  _bindEvents() {
    if (!this.addBtn) return;

    // When Add is clicked: try to sync variant selection, then toggle the picker UI.
    this.addBtn.addEventListener('click', (e) => {
      e.preventDefault();

      let variantId = this.select.value || this.addBtn.getAttribute('data-variant-id');
      if (variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }

      // If the picker is closed, we open and try to pre-select based on currently checked radios (if any)
      if (!this.isOpened()) {
        try { this._selectMatchingVariant(); } catch (err) { console.error(err); }
        this.open();
        this.updateAddToCartbtn();
        return;
      }

      // If the picker is open, clicking the button acts as Cancel (close + clear selection)
      if (this.isOpened()) {
        this.close(true); // pass true to indicate cancel action (clear selection)
        this.updateAddToCartbtn();
        return;
      }

      this.toggle();
    });
  }



  _bindPickerEvents() {
    // listen for radio changes inside the picker
    if (!this.picker) return;
    this.picker.addEventListener('change', (ev) => {
      const target = ev.target;
      if (!target) return;
      if (target.matches('input[type="radio"]')) {
        // on any radio change, attempt to select a matching variant
        try {
          this._selectMatchingVariant();
        } catch (err) {
          console.error('Error selecting variant on radio change:', err);
        }
      }
      this.updateAddToCartbtn();
    });
  }

  _bindQuantityEvents() {
    if (!this.qtyInput) return;

    // Decrease quantity by 1 untill it's equal to 1
    if (this.qtyMinusBtn) {
      this.qtyMinusBtn.addEventListener('click', () => {
        let currentValue = parseInt(this.qtyInput.value, 10) || 1;
        let minValue = parseInt(this.qtyInput.min, 10) || 1;
        if (currentValue > minValue) {
          this.qtyInput.value = currentValue - 1;
        }
        this.updateAddToCartbtn();
      });
    }

    // Increase quantity by 1
    if (this.qtyPlusBtn) {
      this.qtyPlusBtn.addEventListener('click', () => {
        let currentValue = parseInt(this.qtyInput.value, 10) || 1;
        let maxValue = parseInt(this.qtyInput.max, 10) || 99999;
        if (currentValue < maxValue) {
          this.qtyInput.value = currentValue + 1;
        }
        this.updateAddToCartbtn();
      });
    }
  }

  _checkUrlAndInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdParam = urlParams.get('variant');
    if (!variantIdParam || !this.select) return;

    const matchOption = Array.from(this.select.options).find(opt => opt.value === variantIdParam);
    if (!matchOption) return;

    const variantTitleText = matchOption.textContent;
    const typeLabel = this.root.querySelector('h4');
    if (!typeLabel) return;

    // Check if this block corresponds to the chosen variant
    if (variantTitleText.includes(typeLabel.textContent.trim())) {
      // Sync radios inside the picker
      if (this.picker) {
        const radios = Array.from(this.picker.querySelectorAll('input[type="radio"]'));
        const variantOptionParts = variantTitleText.split(' / ').map(s => s.trim());

        const radioGroups = {};
        radios.forEach(r => {
          if (!radioGroups[r.name]) radioGroups[r.name] = [];
          radioGroups[r.name].push(r);
        });

        Object.values(radioGroups).forEach(groupRadios => {
          for (const radio of groupRadios) {
            if (variantOptionParts.includes(radio.value.trim())) {
              radio.checked = true;
              break;
            }
          }
        });

        this._getJoinedHandleFromPicker();
      }

      this.open();
      this.select.value = variantIdParam;

      const price = matchOption.dataset.price;
      const comparePrice = matchOption.dataset.compare;
      this.updatePriceDisplay(price, comparePrice);

      // Delay update just a brief tick to let other blocks initialize properly
      setTimeout(() => {
        this.updateAddToCartbtn();
      }, 50);
    }
  }

  // Check open state
  isOpened() {
    return this.addBtn && this.addBtn.hasAttribute('opened');
  }

  open() {
    if (!this.variantWrapper || !this.addBtn) return;
    this.variantWrapper.classList.remove('hidden');
    this.addBtn.setAttribute('opened', '');
    this.addBtn.textContent = 'Cancel';
    this.root.classList.add('mv-open'); // optional CSS hook
  }

  /**
   * Close the picker.
   * If `clearSelection` is true, clear/unselect the <select class="variant_id">.
   */
  close(clearSelection = false) {
    if (!this.variantWrapper || !this.addBtn) return;
    this.variantWrapper.classList.add('hidden');
    this.addBtn.removeAttribute('opened');
    this.addBtn.textContent = this.originalBtnText;
    this.root.classList.remove('mv-open');

    if (clearSelection) {
      try {
        this._clearVariantSelection();
      } catch (err) {
        console.error('Error clearing variant selection:', err);
      }
    }
  }

  toggle() {
    if (this.isOpened()) this.close(true); // toggling from open -> close acts like cancel and clears selection
    else this.open();
  }
  // simple money format
  formatMoney = (cents) => {
    return `$${(cents / 100).toFixed(2)}`;
  };

  updateAddToCartbtn() {
    // Check if at least one has a selected value
    let hasSelection = false;
    let totalCents = 0;

    this.allVariants.forEach(selectEl => {
      const selectedOption = selectEl.options[selectEl.selectedIndex];
      const variantId = selectedOption && (selectedOption.value || '').trim();
      if (!variantId) return; //skip unslected
      hasSelection = true;

      const priceCents = parseInt(selectedOption.dataset.price || 0, 10) || 0;

      const root = selectEl.closest('select-multivariants') || selectEl.closest('.option--content-wrapper') || selectEl.parentElement;
      let qtyInput = root ? root.querySelector('.quantity__input') : null;

      if (!qtyInput) {
        qtyInput = selectEl.closest('.options--variant')?.querySelector('.quantity__input') || null;
      }

      let qty = 1;
      if (qtyInput) {
        qty = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(qty) || qty < 1) qty = 1;
      }

      totalCents += priceCents * qty;
    });

    if (hasSelection) {
      this.addToCartBtn.removeAttribute('disabled');
      this.addToCartBtn.textContent = `Add to cart - ${this.formatMoney(totalCents)}`;
    } else {
      this.addToCartBtn.setAttribute('disabled', 'disabled');
      this.addToCartBtn.textContent = 'Select Color & Size';
    }
  }

  // price & comparePrice expected in cents
  updatePriceDisplay(price, comparePrice) {

    let html = `
      <span class="price_in_sale">
        <span class="money">${this.formatMoney(price)}</span>
      </span>
    `;

    if (comparePrice && comparePrice > price) {
      html += `
        <span class="price_in_regular">
          <s><span class="money">${this.formatMoney(comparePrice)}</span></s>
        </span>
      `;
    }

    this.updatePrice.innerHTML = html;
  }

  /**
   * Find the <multivariant-selects> picker inside this root and return the joined handleized string
   * Example: ["Light Grey","Back Cushion","M"] -> "light-grey-back-cushion-m"
   */
  _getJoinedHandleFromPicker() {
    const picker = this.picker ||
      (this.variantWrapper && this.variantWrapper.querySelector('multivariant-selects')) ||
      this.root.querySelector('multivariant-selects');

    if (!picker) return null;

    // find checked radios (works for both swatches and pills)
    const checked = Array.from(picker.querySelectorAll('input[type="radio"]:checked'));
    if (!checked.length) return null;

    const values = checked.map(inp => (inp.value || '').toString().trim()).filter(Boolean);
    if (!values.length) return null;

    const handles = values.map(v => this._handleize(v));

    // update the label text
    this.optionLabels.forEach((label, index) => {
      if (values[index] !== undefined) {
        label.textContent = values[index];
      }
    });

    return handles.join('-');
  }

  /**
   * Mirror Shopify's handleize:
   * - lower-case
   * - remove diacritics
   * - replace non-alphanumeric with hyphens
   * - collapse multiple hyphens
   * - trim leading/trailing hyphens
   */
  _handleize(str) {
    if (typeof str !== 'string') return '';
    return str
      .toLowerCase()
      .normalize('NFD')                 // separate accents
      .replace(/[\u0300-\u036f]/g, '')  // remove accents
      .replace(/[^a-z0-9]+/g, '-')      // replace non-alnum with hyphen
      .replace(/^-+|-+$/g, '')          // trim hyphens from ends
      .replace(/-{2,}/g, '-');          // collapse multiple hyphens
  }

  /**
   * Compare the joined handle with option[data-title] and select matching option if found.
   * Returns true if matched, false otherwise.
   */
  _selectMatchingVariant() {
    const joinedHandle = this._getJoinedHandleFromPicker();
    if (!joinedHandle) {
      // No fully checked set yet — don't change selection
      // (If you want to clear selection when partial/none, change behavior here)
      // console.warn('No checked variant inputs found inside multivariant-selects.');
      return false;
    }

    const select = this.root.querySelector('select.variant_id') || this.root.querySelector('select[name="variant_id"]');
    if (!select) {
      console.warn('No <select class="variant_id"> found in select-multivariants block.');
      return false;
    }

    const options = Array.from(select.options || []);
    const match = options.find(opt => {
      const dataTitle = opt.dataset && opt.dataset.title ? opt.dataset.title : opt.getAttribute('data-title');

      return (dataTitle || '') === joinedHandle;
    });

    if (match) {
      select.value = match.value;
      const changeEvent = new Event('change', { bubbles: true });
      select.dispatchEvent(changeEvent);

      // update price
      const price = this.select.options[this.select.selectedIndex].dataset.price;
      const comparePrice = this.select.options[this.select.selectedIndex].dataset.compare;
      this.updatePriceDisplay(price, comparePrice);

      // update URL state
      if (this.isOpened()) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.value);
        window.history.replaceState({}, '', url.toString());
      }

      return true;
    } else {
      // No exact match — do nothing (or clear if desired)
      console.warn('No variant option matched handle:', joinedHandle);
      return false;
    }
  }

  /**
   * Clear/unselect the <select class="variant_id"> option and dispatch change.
   * This sets select.value = '' and selectedIndex = -1 where supported.
   */
  _clearVariantSelection() {
    const select = this.root.querySelector('select.variant_id') || this.root.querySelector('select[name="variant_id"]');
    if (!select) return;
    try {
      // try to clear selection
      select.value = '';
      // some browsers don't reflect empty value, so set selectedIndex to -1
      if (typeof select.selectedIndex !== 'undefined') select.selectedIndex = -1;
    } catch (err) {
      // fallback: iterate and remove selected attribute
      Array.from(select.options || []).forEach(opt => opt.removeAttribute('selected'));
    }
    // notify listeners
    const changeEvent = new Event('change', { bubbles: true });
    select.dispatchEvent(changeEvent);
  }
}

/* Auto-init all select-multivariants on DOM ready */
(function initSelectMultivariants() {
  function initAll() {
    const nodes = Array.from(document.querySelectorAll('select-multivariants'));
    nodes.forEach(node => {
      // avoid double-init by storing an instance on the DOM node
      if (!node.__selectMultivariantsInstance) {
        node.__selectMultivariantsInstance = new SelectMultivariants(node);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

// =============================================//

// Add items to the cart

// Add-to-cart handler for multivariant groups
(function () {
  const ADD_BTN_SELECTOR = '.add-items-to-cart.button';
  const VARIANT_SELECTOR = 'select.variant_id';
  const QTY_SELECTOR = '.quantity__input';
  const OPTIONS_CONTAINER_SELECTOR = '.options--variant';

  async function addItemsToCart(items) {
    const results = [];
    for (const item of items) {
      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(item.id, 10), quantity: parseInt(item.quantity, 10) })
        });

        if (!resp.ok) {
          const errText = await resp.text().catch(() => null);
          throw new Error(`HTTP ${resp.status}: ${errText || resp.statusText}`);
        }

        const json = await resp.json();
        results.push({ success: true, response: json, item });
      } catch (err) {
        results.push({ success: false, error: err, item });
        // stop on first failure (optional). If you want to continue adding others, comment out the next line.
        // break;
      }
    }
    return results;
  }

  function collectItemsFromOptionsContainer(container) {
    const items = [];
    // find every select within the container
    const selects = Array.from(container.querySelectorAll(VARIANT_SELECTOR));
    selects.forEach(select => {
      const selectedVal = (select.value || '').toString().trim();
      if (!selectedVal) return; // skip empties

      // find the closest select-multivariants root and then find qty inside it
      const root = select.closest('select-multivariants') || select.parentElement;
      let qtyInput = root ? root.querySelector(QTY_SELECTOR) : null;

      // fallback: search nearby for a quantity input (in case markup differs)
      if (!qtyInput) {
        qtyInput = container.querySelector(QTY_SELECTOR);
      }

      let qty = 1;
      if (qtyInput) {
        qty = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(qty) || qty <= 0) qty = 1;
      }

      items.push({ id: selectedVal, quantity: qty });
    });
    return items;
  }

  function showTemporaryMessage(el, message, duration = 3000) {

  }

  async function closeOptions() {
    if (window.multivariant.settings.mvs_style == 'advanced') {
      const buttons = Array.from(document.querySelectorAll('select-multivariants button[opened]'));
      const inputs = Array.from(document.querySelectorAll('.bulk-qty-selector input[name="quantity"]'));

      if (!buttons.length) return;
      let index = 0;
      const clickNext = () => {
        const btn = buttons[index];
        if (btn) btn.click();

        index++;
        if (index < buttons.length) {
          setTimeout(clickNext, 350); // wait 350ms before next click
        }
      };
      clickNext();
      if (inputs.length > 0) {
        inputs.forEach(input => {
          input.value = 1;
        })
      }
    }
  }

  function showFinalCartDrawer() {
    try {
      fetch(`${routes.cart_url}?sections=cart-icon-bubble,cart-drawer`)
        .then((response) => response.json()) // Parse response as JSON
        .then((data) => {
          // fetch cart before update drawer
          fetchShopifyCart().then(cart => {
            if (cart) {
              Debutify.cart.total_price = cart.total_price;
              console.log('Total: ', Debutify.cart.total_price);
            }
          });
          // Update cart-icon-bubble section
          const bubbleSectionHtml = data['cart-icon-bubble'];
          if (bubbleSectionHtml) {
            const bubbleParser = new DOMParser().parseFromString(bubbleSectionHtml, 'text/html');
            const newBubbleSection = bubbleParser.querySelector('cart-bubble');
            const existingBubbleContainer = document.querySelector('cart-bubble');
            if (newBubbleSection && existingBubbleContainer) {
              existingBubbleContainer.replaceWith(newBubbleSection);
            }
          }

          // Update cart-drawer section
          const drawerSectionHtml = data['cart-drawer'];
          if (drawerSectionHtml) {
            const drawerParser = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
            const existingCartDrawer = document.querySelector('cart-drawer');
            const newCartDrawer = drawerParser.querySelector('cart-drawer');
            if (newCartDrawer && existingCartDrawer) {
              existingCartDrawer.replaceWith(newCartDrawer);
            }
            const cartGoal = document.querySelector('.product__info-wrapper dtc-goals-bar');
            const newGoal = newCartDrawer.querySelector('dtc-goals-bar');
            if (cartGoal && newGoal) {
              cartGoal.innerHTML = newGoal.innerHTML;

            }
          }
        })
        .then(() => {
          const cartDrawerElement = document.querySelector('cart-drawer');
          if (cartDrawerElement) {
            cartDrawerElement.classList.remove('is-empty');
            Debutify.showCartDrawer();
            document.body.classList.add("overflow-hidden");
          }
        })
        .then(() => {
          closeOptions();
        })
        .catch((e) => {
          console.error(e);
        });
    } catch (error) {
      console.error("Error adding to cart:", error);
    }

  }
  async function fetchShopifyCart() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const cartData = await response.json();

      return cartData;
    } catch (error) {
      console.error('Error fetching Shopify cart:', error);
      return null;
    }
  }

  async function onAddToCartClick(e) {
    const btn = e.currentTarget;
    btn.setAttribute('disabled', 'true');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      // gather items from all .options--variant containers (supports multiple groups)
      const containers = Array.from(document.querySelectorAll(OPTIONS_CONTAINER_SELECTOR));
      let allItems = [];
      containers.forEach(container => {
        allItems = allItems.concat(collectItemsFromOptionsContainer(container));
      });

      // remove duplicates by variant id (optional) — if you want to sum quantities instead:
      // comment out the dedupe block to keep each item separate.
      const deduped = {};
      allItems.forEach(it => {
        if (!it.id) return;
        if (!deduped[it.id]) deduped[it.id] = 0;
        deduped[it.id] += Number(it.quantity || 1);
      });
      const items = Object.keys(deduped).map(id => ({ id, quantity: deduped[id] }));

      if (!items.length) {
        showTemporaryMessage(btn, 'No items selected');
        btn.removeAttribute('disabled');
        btn.textContent = originalText;
        return;
      }

      // perform adds
      const results = await addItemsToCart(items);

      const failures = results.filter(r => !r.success);
      if (failures.length === 0) {
        // success
        const successDetail = {
          itemsAdded: results.map(r => ({ id: r.item.id, quantity: r.item.quantity, response: r.response })),
          rawResults: results
        };

        // fire a custom event so the host page can react
        document.dispatchEvent(new CustomEvent('multivariants:added-to-cart', { detail: successDetail }));

        showTemporaryMessage(btn, 'Added to cart!');
        showFinalCartDrawer();

      } else {
        // partial or full failure
        const failDetail = {
          failures: failures.map(f => ({ item: f.item, error: f.error })),
          results
        };
        document.dispatchEvent(new CustomEvent('multivariants:add-to-cart-error', { detail: failDetail }));
        showTemporaryMessage(btn, 'Failed adding some items');
        console.error('Add-to-cart failures:', failDetail);
      }
    } catch (err) {
      document.dispatchEvent(new CustomEvent('multivariants:add-to-cart-error', { detail: { error: err } }));
      console.error('Unexpected error adding items to cart:', err);
      showTemporaryMessage(btn, 'Error adding items');
    } finally {
      btn.removeAttribute('disabled');
      btn.textContent = originalText;
    }
  }

  // wire up buttons on DOM ready
  function init() {
    const addButtons = Array.from(document.querySelectorAll(ADD_BTN_SELECTOR));
    addButtons.forEach(btn => {
      // avoid double-binding
      if (btn.__mvAddToCartBound) return;
      btn.addEventListener('click', onAddToCartClick);
      btn.__mvAddToCartBound = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

